import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import '../../theme/index.scss';
import LandingPageComponent from './landing-page.component';

const rootElement = document.getElementById('isp-landing-page-container');

const App = () => {
    return <LandingPageComponent />;
};

if (rootElement) {
    const root = createRoot(rootElement);
    const render = (Component: React.ComponentType) => {
        root.render(
            <React.StrictMode>
                <Component />
            </React.StrictMode>
        );
    };

    render(App);

    if (module.hot) {
        module.hot.accept('./App', () => {
            const NextApp = require('./App').default;
            render(NextApp);
        });
    }
} else {
    console.error('Root element not found');
}
